import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	IconButton,
	MenuItem,
	OutlinedInput,
	Pagination,
	Select,
} from "@mui/material";
import {
	deleteMultipleSupportTicketAction,
	getSupportTicketAction,
} from "../../Actions/SupportTicketAction";
import { getPermissionData, getUserData } from "../../Actions/common";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import {
	default as CoustomTooltip,
	default as CustomTooltip,
} from "../../Assets/customTheme/customtooltip";
import {
	MyCloseIcon,
	MyDeleteOutlineOutlinedIcon,
	MyInfoOutlinedIcon,
	MySearchIcon,
	MyVisibilityIcon,
} from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { API_IMAGE_URL, ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import DialogOpenComponent from "./DialogOpenComponent";
import SupportTicketModel from "./EditSupportTicket";
import renderStatusBadge from "../../utils/badges";
import { CommonTooltip } from "../../utils/tooltip";
import DateRangePicker from "../Common/DateRangePicker";
import showConfirmation from "../../utils/Conformation";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
		},
	},
};

const getDefaultDateRange = () => {
	const end = new Date();
	const start = new Date();
	start.setMonth(start.getMonth() - 1);
	return { from: start, to: end };
};

const CustomToolbar = ({
	SelectDropdown_SX,
	searchValue,
	handleSearchApi,
	handleFilterData,
	handleResetFilters,
	handleChangeDropdown,
	statusFilter,
	selectedRows,
	handleDeleteSelected,
	filterButtonDisabled,
	resetButtonDisabled,
	selectedRange,
	onRangeChange,
}) => {
	return (
		<div className="custom-header">
			<div className="card border-rounded-0 fiter-card">
				<div className="card-body p-5 pb-0">
					<div className="row">
						<div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2 col-12 mb-5">
							<div className="position-relative">
								<MySearchIcon className="fs-2 text-gray-500 position-absolute top-50 translate-middle-y ms-4" />
								<input
									type="text"
									data-kt-table-widget-4="search"
									className="search-input form-control ps-12"
									placeholder="Search"
									name="search"
									value={searchValue}
									onChange={handleSearchApi}
								/>
							</div>
						</div>
						<div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2 col-12 mb-5">
							<DateRangePicker
								selectedRange={selectedRange}
								onRangeChange={onRangeChange}
								maxDate={new Date()}
								placeholder="Select date range"
							/>
						</div>

						<div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2 col-12 mb-5">
							<FormControl className="w-100">
								<Select
									displayEmpty
									value={statusFilter}
									name="dropdown"
									onChange={(e) =>
										handleChangeDropdown(e, "statusFilter")
									}
									input={<OutlinedInput />}
									MenuProps={MenuProps}
									sx={SelectDropdown_SX}
								>
									<MenuItem value="all">
										Select Status
									</MenuItem>
									<MenuItem value="3">Completed</MenuItem>
									<MenuItem value="0">Pending</MenuItem>
									<MenuItem value="1">In-Progress</MenuItem>
									<MenuItem value="2">Rejected</MenuItem>
									<MenuItem value="4">On-Hold</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className="col-auto gap-3 d-flex ms-auto">
							<CustomTooltip title="Filter" placement="top" arrow>
								<span>
									<button
										className="btn text-primary btn-light btn-icon"
										onClick={handleFilterData}
										disabled={filterButtonDisabled}
									>
										<TableFilte />
									</button>
								</span>
							</CustomTooltip>

							<CustomTooltip title="Reset" placement="top" arrow>
								<span>
									<button
										className="btn text-primary btn-light btn-icon"
										onClick={handleResetFilters}
										disabled={resetButtonDisabled}
									>
										<TableReset />
									</button>
								</span>
							</CustomTooltip>

							<CoustomTooltip
								title="Column Filter"
								placement="top"
								arrow
							>
								<span style={{ display: "inline-block" }}>
									<GridToolbarColumnsButton
										slotProps={{
											tooltip: { title: "" },
											button: {
												className:
													"btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
												style: {
													width: "47px",
													height: "44px",
													minWidth: "unset",
													borderRadius: "8px",
												},
												startIcon: <TableColumns />,
											},
										}}
									/>
								</span>
							</CoustomTooltip>
							{selectedRows.length !== 0 && (
								<CoustomTooltip
									title="Delete"
									placement="top"
									arrow
								>
									<span style={{ display: "inline-block" }}>
										<button
											className="btn btn-outline-danger  btn-icon btn-outline "
											onClick={handleDeleteSelected}
											disabled={selectedRows.length === 0}
										>
											<MyDeleteOutlineOutlinedIcon />
										</button>
									</span>
								</CoustomTooltip>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const SupportTicketSection = () => {
	const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
		ITEMS_PER_PAGE_OPTIONS[0]
	);
	const [selectedRows, setSelectedRows] = useState([]);
	const [SupportTicketById, setSupportTicketById] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	const isMenuOpen = Boolean(anchorEl);

	const [loading, setLoading] = useState(true);
	const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
	const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
	const [supportTicketData, setSupportTicketData] = useState([]);
	const [ticketId, setTicketId] = useState(0);
	const [parentComponent, setParentComponent] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [searchValue, setSearchValue] = useState("");
	const [enableFilterButton, setEnableFilterButton] = useState(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [snackbar, setSnackbar] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [shouldFetchData, setShouldFetchData] = useState(1);
	const [openModal, setOpenModal] = useState(false);
	const [openStatusModal, setOpenStatusModal] = useState(false);
	const [selectedAttachment, setSelectedAttachment] = useState(null);
	const [statusFilter, setStatusFilter] = useState("all");

	const defaultRange = getDefaultDateRange();
	const [startDate, setStartDate] = useState(defaultRange.from.toISOString());
	const [endDate, setEndDate] = useState(defaultRange.to.toISOString());
	const [selectedRange, setSelectedRange] = useState(defaultRange);
	const [selectedDescription, setSelectedDescription] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);
	const userData = localStorage.getItem("userData") ? getUserData() : null;
	const permissionData = localStorage.getItem(
		`${userData?.id}_permissionData`
	)
		? getPermissionData(`${userData?.id}_permissionData`)
		: [];
	const hasPermission = permissionData[0]?.role_permissions?.find(
		(m) => m?.module && m?.module?.slug === "support-ticket"
	);

	const getSupportTicketData = useCallback(async () => {
		setLoading(true);
		await getSupportTicketAction(
			selectedRowsPerPage,
			currentPage,
			searchValue,
			startDate,
			endDate,
			statusFilter
		)
			.then((res) => {
				const { data } = res;
				if (data.status === 202) {
					setSnackbar({
						open: true,
						message: data?.message,
						severity: "info",
					});
				}
				if (data.status === 200) {
					setSupportTicketData(data?.data);
					setTotalRecords(data?.totalRecords || 0);
				}
			})
			.catch((error) => {
				setSnackbar({
					open: true,
					message: error?.response?.data?.message,
					severity: "error",
				});
			})
			.finally(() => {
				setLoading(false);
			});
	},[selectedRowsPerPage,currentPage,searchValue,startDate,endDate,statusFilter]);

	useEffect(() => {
		if (shouldFetchData) {
			getSupportTicketData();
			setShouldFetchData(0);
		}
	}, [shouldFetchData,getSupportTicketData]);

	useEffect(() => {
		const now = new Date();
		const oneMonthAgo = new Date();
		oneMonthAgo.setMonth(now.getMonth() - 1);

		setStartDate(oneMonthAgo.toISOString());
		setEndDate(now.toISOString());
		setSelectedRange({ from: oneMonthAgo, to: now });
	}, []);

	const handleCloseSnackbar = () => {
		setSnackbar({ ...snackbar, open: false });
	};



	const handleSearchApi = (e) => {
		const inputValue = e.target.value;
		if (inputValue.length === 0) {
			setFilterButtonDisabled(true);
		} else {
			setFilterButtonDisabled(false);
		}
		setSearchValue(inputValue);
	};

	const handleResetFilters = () => {
		const defaultRange = getDefaultDateRange();

		setSelectedRange(defaultRange);
		setStartDate(defaultRange.from.toISOString());
		setEndDate(defaultRange.to.toISOString());

		setSearchValue("");
		setStatusFilter("all");
		setCurrentPage(1);
		setFilterButtonDisabled(true);
		setResetButtonDisabled(true);
		setShouldFetchData(1);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setSelectedAttachment(null);
	};

	const handleCloseStatusModal = () => {
		setOpenStatusModal(false);
	};

	const handleChangeDropdown = (e, filterName) => {
		const selectedValue = e.target.value;
		if (selectedValue === "all") {
			setFilterButtonDisabled(true);
		} else {
			setFilterButtonDisabled(false);
		}
		if (filterName === "statusFilter") {
			setStatusFilter(selectedValue);
		}
	};

	const handleRangeChange = (range) => {
		setFilterButtonDisabled(false);

		// If user selects a range, we can enable reset
		setResetButtonDisabled(false);

		if (!range) {
			setSelectedRange({ from: undefined, to: undefined });
			setStartDate(null);
			setEndDate(null);
			return;
		}

		setSelectedRange(range);

		if (range.from) {
			const year = range.from.getFullYear();
			const month = range.from.getMonth();
			const day = range.from.getDate();
			const startDateObj = new Date(
				Date.UTC(year, month, day, 0, 0, 0, 0)
			);
			setStartDate(startDateObj.toISOString());
		}

		if (range.to) {
			const year = range.to.getFullYear();
			const month = range.to.getMonth();
			const day = range.to.getDate();
			const endDateObj = new Date(
				Date.UTC(year, month, day, 23, 59, 59, 999)
			);
			setEndDate(endDateObj.toISOString());
		}
	};

	const handleFilterData = () => {
		setCurrentPage(1);
		setEnableFilterButton(true);
		setLoading(true);
		setShouldFetchData(1);
		setSupportTicketData([]);
		setFilterButtonDisabled(true);
		setResetButtonDisabled(false);
	};

	const SelectDropdown_SX = {
		"& .MuiSelect-select": {
			padding: "11px",
			textAlign: "start",
		},
		fieldset: {
			borderColor: "#e1e3ea !important",
			borderRadius: "30px",
		},
	};

	const handleDelete = async (e, ticketId) => {
		e.stopPropagation();

			await showConfirmation("simpleDelete", {
			entityName: "Support Ticket",
			entityId: ticketId,
			action: deleteMultipleSupportTicketAction,
			onSuccess: (res) => {
				setSelectedRows([]);
				setCurrentPage(1);
				getSupportTicketData();
			},
			onError: (error) => {
				setSnackbar({
					open: true,
					message: error?.response?.data?.message || "Something went wrong",
					severity: "error",
				});
			},
			showCancelledMsg: true,
		});
	};
	const handleDeleteSelected = async () => {
		if (selectedRows.length === 0) return;

		const result = await showConfirmation("simpleMultipleDelete", {
			entityName: "Support Ticket",
			entityIds: selectedRows,
			action: deleteMultipleSupportTicketAction,
			onSuccess: (res) => {
				setSelectedRows([]);
				setCurrentPage(1);
				getSupportTicketData();
			},
			onError: (error) => {
				setSnackbar({
					open: true,
					message: error?.response?.data?.message || "Something went wrong",
					severity: "error",
				});
				setSelectedRows([]);
			},
			showCancelledMsg: true,
		});

		if (result?.cancelled) {
			setSelectedRows([]);
		}
	};

	// const handleSelectAll = (event) => {
	// 	if (event.target.checked) {
	// 		const pendingIds = supportTicketData
	// 			.filter((ticket) => ticket.status === "Pending")
	// 			.map((ele) => ele.id);
	// 		setSelectedRows(pendingIds);
	// 	} else {
	// 		setSelectedRows([]);
	// 	}
	// };

	// const handleRowSelection = (event, ele) => {
	// 	const selectedId = ele.id;

	// 	if (event.target.checked) {
	// 		setSelectedRows((prevSelectedRows) => [
	// 			...prevSelectedRows,
	// 			selectedId,
	// 		]);
	// 	} else {
	// 		setSelectedRows((prevSelectedRows) =>
	// 			prevSelectedRows.filter((id) => id !== selectedId)
	// 		);
	// 	}
	// };

	const handleDialogOpen = (data, id, parentComponentDetails) => {
		setTicketId(id);
		setSelectedDescription(data);
		setParentComponent(parentComponentDetails);
		setDialogOpen(true);
	};

	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const columns = [
		{
			field: "ticketCode",
			headerName: "Ticket No.",
			flex: 1,
			align: "left",
			headerAlign: "left",
			renderCell: (params) => <>#{params.row.ticketCode}</>,
		},
		// {
		//     field: "name",
		//     headerName: "User Name",
		//     flex: 1,
		//     align: "left",
		//     headerAlign: "left",
		// },
		{
			field: "domainUrl",
			headerName: "Tenant",
			flex: 1,
			align: "left",
			headerAlign: "left",
			renderCell: (params) => {
				return (
					<span title={params.row.domainUrl}>
						{params.row.domainUrl}
					</span>
				);
			},
		},

		{
			field: "moduleName",
			headerName: "Module",
			flex: 1,
			align: "left",
			headerAlign: "left",
			renderCell: (params) =>
				params.row.moduleName ? (
					<span title={params.row.moduleName}>
						{params.row.moduleName}
					</span>
				) : (
					"N/A"
				),
		},
		{
			field: "description",
			headerName: "Description",
			flex: 1,
			headerAlign: "center",
			renderCell: (params) => (
				<>
					{params.row.description !== "" &&
					params.row.description !== null ? (
						<span
							className="ms-1"
							onClick={() =>
								handleDialogOpen(
									params.row.description,
									params.row.id,
									"description"
								)
							}
							style={{
								cursor: "pointer",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								height: "100%",
							}}
						>
							{params?.row?.description !== "" ? (
								<CommonTooltip
									title="description"
									placement="top"
									arrow
								>
									<IconButton className="text-warnning">
										<MyInfoOutlinedIcon className="" />
									</IconButton>
								</CommonTooltip>
							) : (
								<span className="ms-1">-</span>
							)}
						</span>
					) : (
						<span className="ms-1">
							<span className="ms-1">-</span>
						</span>
					)}
				</>
			),
		},
		{
			field: "status",
			headerName: "Status",
			flex: 1,
			align: "left",
			headerAlign: "left",
			sortable: false,
			renderCell: (params) => {
				const statusMap = {
					0: { text: "Pending", status: "warning" },
					1: { text: "In Progress", status: "info" },
					2: { text: "Failed", status: "error" },
					3: { text: "Completed", status: "success" },
					4: { text: "On Hold", status: "inactive" },
				};

				const statusValue = params.value;
				const { text, status } = statusMap[statusValue] || {
					text: "Unknown",
					status: "default",
				};

				return renderStatusBadge({ status, title: text });
			},
		},

		{
			field: "Request Date",
			flex: 1,
			align: "left",
			headerAlign: "left",
			// minWidth: 100,
			renderCell: (params) => {
				const formatedDate = formatDateTime(params.row.createdAt, true);
				return <span title={formatedDate}>{formatedDate}</span>;
			},
		},
	];

	if (hasPermission?.canView || hasPermission?.canDelete) {
	// 	columns.unshift({
	// 		field: "select-checkbox", // Added a field name
	// 		headerName: "",
	// 		width: 50,
	// 		minWidth: 50,
	// 		sortable: false, // Disable sorting for this column
	// 		filterable: false, // Disable filtering for this column
	// 		disableColumnMenu: true,
	// 		align: "left",
	// 		headerAlign: "left",
	// 		renderHeader: () => (
	// 			<Checkbox
	// 				onChange={handleSelectAll}
	// 				disabled={supportTicketData.length === 0}
	// 				checked={
	// 					supportTicketData.length > 0 &&
	// 					selectedRows.length ===
	// 						supportTicketData?.filter(
	// 							(ticket) => ticket.status === "Pending"
	// 						).length &&
	// 					supportTicketData.some(
	// 						(ticket) => ticket.status === "Pending"
	// 					)
	// 				}
	// 				sx={MyCheckboxIcon}
	// 			/>
	// 		),
	// 		renderCell: (params) => {
	// 			return (
	// 				<Checkbox
	// 					onChange={(event) =>
	// 						handleRowSelection(event, params.row)
	// 					}
	// 					checked={selectedRows.includes(params.row.id)}
	// 					sx={MyCheckboxIcon}
	// 				/>
	// 			);
	// 		},
	// 	});

		columns.push({
			field: "actions",
			headerName: "Action",
			sortable: false,
			disableColumnMenu: true,
			GridColDef: false,
			flex: 1,
			align: "left",
			minWidth: 170,
			headerAlign: "left",
			renderCell: (params) => {
				return (
					<>
						{hasPermission?.canView && (
							<CommonTooltip title="View" placement="top" arrow>
								<IconButton
									className="btn-custom-i text-primary me-3"
									onClick={() => handleEditClick(params.row)}
								>
									<MyVisibilityIcon />
								</IconButton>
							</CommonTooltip>
						)}
						{hasPermission?.canDelete && (
							<CommonTooltip title="Delete" placement="top" arrow>
								<IconButton
									className="btn-custom-i text-primary me-3"
									onClick={(e) =>
										handleDelete(e, params.row.id)
									}
								>
									<MyDeleteOutlineOutlinedIcon />
								</IconButton>
							</CommonTooltip>
						)}
					</>
				);
			},
		});
	}

	const handleEditClick = (rowData) => {
		setSupportTicketById(rowData);
		setOpenStatusModal(true);
	};

	const handleRowsPerPageChange = (event) => {
		const newValue = parseInt(event.target.value);
		setSelectedRowsPerPage(newValue);
		setCurrentPage(1);
		setLoading(true);
		setShouldFetchData(1);
		setSupportTicketData([]);
	};

	const handleExportClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<BreadcrumbsComponent />
			<DataGrid
				localeText={{ toolbarColumns: "" }}
				rows={supportTicketData}
				columns={columns}
				// pagination={false}
				autoHeight
				hideFooterRowCount={true}
				hideFooterPagination={true}
				hideFooter={true}
				loading={loading}
				disableRowSelectionOnClick
				slots={{
					toolbar: CustomToolbar,
					noRowsOverlay: CustomNoRowsOverlay,
				}}
				slotProps={{
					toolbar: {
						SelectDropdown_SX,
						searchValue,
						handleSearchApi,
						handleFilterData,
						handleResetFilters,
						enableFilterButton,
						handleChangeDropdown,
						statusFilter,
						handleExportClick,
						handleMenuClose,
						isMenuOpen,
						anchorEl,
						selectedRows,
						selectedRange,
						onRangeChange: handleRangeChange,
						handleDeleteSelected,
						filterButtonDisabled,
						resetButtonDisabled,
					},
				}}
				sx={DataGrid_SX}
			/>

			{supportTicketData.length > 0 && (
				<div className="card-footer d-flex align-items-center justify-content-between mt-7">
					<div className="d-flex align-items-center">
						<label className="fw-semibold me-3">
							Row per page:
						</label>
						<FormControl
							variant="standard"
							style={{
								minWidth: 50,
							}}
						>
							<Select
								labelId="rows-per-page-label"
								id="rows-per-page"
								value={selectedRowsPerPage}
								onChange={handleRowsPerPageChange}
								label="Rows per page"
							>
								{ITEMS_PER_PAGE_OPTIONS.map((option) => (
									<MenuItem key={option} value={option}>
										{option}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</div>
					<Pagination
						count={Math.ceil(totalRecords / selectedRowsPerPage)}
						siblingCount={0}
						page={currentPage}
						onChange={(event, value) => {
							if (value !== currentPage) {
								setCurrentPage(value);
								setShouldFetchData(1);
								setSupportTicketData([]);
								setLoading(true);
							}
						}}
						variant="outlined"
						shape="rounded"
						className="custom-pagination mt-0 ms-5"
					/>
				</div>
			)}
			<Dialog
				open={openModal}
				onClose={handleCloseModal}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle>
					Issues Image Preview
					<IconButton
						aria-label="close"
						onClick={handleCloseModal}
						sx={{ position: "absolute", right: 8, top: 8 }}
					>
						<MyCloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					{selectedAttachment ? (
						selectedAttachment.endsWith(".pdf") ? (
							<iframe
								src={`${API_IMAGE_URL}/${selectedAttachment}`}
								width="100%"
								height="500px"
								title="attachment"
							></iframe>
						) : (
							<img
								src={`${API_IMAGE_URL}/${selectedAttachment}`}
								alt="Attachment Preview"
								style={{ width: "100%", height: "auto" }}
							/>
						)
					) : (
						"No Attachment Available"
					)}
				</DialogContent>
			</Dialog>

			{dialogOpen && (
				<DialogOpenComponent
					ticketId={ticketId}
					data={selectedDescription}
					onClose={handleDialogClose}
					parentComponent={parentComponent}
				/>
			)}

			{openStatusModal && (
				<SupportTicketModel
					open={openStatusModal}
					handleClose={handleCloseStatusModal}
					ticketData={SupportTicketById}
					refetchSupportTickets={getSupportTicketData}
					setSnackbar={setSnackbar}
					permission={hasPermission}
				/>
			)}

			<CustomSnackbar
				open={snackbar.open}
				message={snackbar.message}
				severity={snackbar.severity}
				onClose={handleCloseSnackbar}
			/>
		</div>
	);
};

export default SupportTicketSection;
